import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import customerAddress from './customerAddress'
import dealer from './dealer'

import offer from './offer'
import evb from './evb'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    customerAddress,
    dealer,
    offer,
    evb,
  }
})